import { createSlice } from '@reduxjs/toolkit';
import { MailActions } from './index';
const InitialState = {
    contact: {},
    selector: {
        focused: '',
        add: false,
        pendingItem: null,
    },
    selectedTags: {
        type: '',
        emails: [],
    },
    currentEditingMail: {
        type: '',
        current: '',
    },
};
const contactSlice = createSlice({
    name: 'tempContactReducer',
    initialState: InitialState,
    reducers: {
        doCreateFormExternal: (state, action) => {
            state.contact.external = action.payload;
        },
        doCreateAfterFlag: (state, action) => {
            state.contact.createFlag = action.payload;
        },
        doFocusSelector: (state, action) => {
            state.selector.focused = action.payload;
            state.selectedTags = { emails: [], type: '' };
        },
        doAddItemToSelector: (state, action) => {
            const { add, pendingItem } = action.payload;
            state.selector.add = add;
            state.selector.pendingItem = pendingItem;
        },
        doSelectTags: (state, action) => {
            const { type, emails } = action.payload;
            state.selectedTags.type = type;
            state.selectedTags.emails = Array.from(new Set(emails));
            state.selector.focused = type;
        },
        doSetCurrentEditingMail: (state, action) => {
            const { type, current } = action.payload;
            state.currentEditingMail = { type, current };
        },
    },
    extraReducers: builder => {
        builder.addCase(MailActions.doCloseMail, state => {
            state.selectedTags = { emails: [], type: '' };
        });
    },
});
export const { actions } = contactSlice;
export default contactSlice.reducer;
